/* eslint-disable camelcase */
import React, { useState } from "react";
import { updateLogSubscription } from "../../helper/api";
import { useDispatch, useSelector } from "react-redux";
import { IS_OPEN_LOGIN_FORM } from "../../helper/actions";
import { SocialMediaShoutout } from "../../molecules/social-media-shoutout";
import { get } from "lodash";
import queryString from "query-string";
import "./student-subscription-page.m.css";

export function SocialMediaShoutoutContainer() {
  const member = useSelector(state => get(state, ["member"], null));

  const [data, setData] = useState({
    twitterHandle: null,
    instagramHandle: null,
    userConsentForShoutOutOnStudentSubscription: "yes",
    loading: false,
    success: false,
    error: null
  });

  const { instagramHandle, twitterHandle, userConsentForShoutOutOnStudentSubscription, loading } = data;

  const handleChange = e => {
    const { name, value } = e.target;
    setData(prevState => ({ ...prevState, [name]: value }));
  };

  const dispatch = useDispatch();

  const showLoginPopup = () => {
    dispatch({
      type: IS_OPEN_LOGIN_FORM,
      payload: true
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!member) {
      await showLoginPopup();
      return;
    }

    setData({
      ...data,
      loading: true,
      error: null,
      success: false
    });

    const queryParams = queryString.parse(window.location.search);

    const { gateway, razorpay_invoice_id, razorpay_payment_id, amount, quantity } = queryParams;

    try {
      const updateObject = {
        sheetIndex: 1,
        data: {
          member_id: member.id,
          member_name: member.name,
          phone: member["phone-number"],
          email: member.email,
          gateway,
          razorpay_invoice_id,
          razorpay_payment_id,
          amount,
          quantity,
          userConsentForShoutOutOnStudentSubscription,
          instagramHandle,
          twitterHandle
        }
      };

      await updateLogSubscription(updateObject);

      setData({
        ...data,
        loading: false,
        success: true
      });
    } catch (e) {
      setData({
        ...data,
        error: e.message,
        loading: false
      });
      console.log("error while completing payment ", e);
    }
  };

  return data.success ? (
    <div styleName="student-success-wrapper">
      <h4 styleName="student-success-text">Thank you! Submitted Successfully</h4>
      <button
        onClick={() => global.app.navigateToPage(dispatch, "/")}
        href="/"
        styleName="pay-button"
        style={{ width: "max-content" }}
      >
        Go back to Home page
      </button>
    </div>
  ) : (
    <form onSubmit={handleSubmit}>
      <h4 style={{ textAlign: "center", marginBottom: "2rem" }}>
        You’re a star! Thank you so much for sponsoring subscriptions.
      </h4>
      <SocialMediaShoutout
        name="userConsentForShoutOutOnStudentSubscription"
        onChange={handleChange}
        values={{
          twitterHandle,
          instagramHandle,
          userConsentForShoutOutOnStudentSubscription
        }}
      />
      <button styleName="pay-button" type="submit" disabled={loading}>
        Submit
      </button>
      {data.error}
    </form>
  );
}
